module.exports = __webpack_public_path__ + "img/payment-directDebit.8224e75.svg";